import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';

import {useEcStore} from '../../../store/slices/ecStore';

const HandWithSmartphone = '/messages/hand-smartphone.png';
import './MessageAddress.style.scss';

export const MessageAddress = (props) => {
  const addresses = useEcStore((state) => state.ec.addresses);
  const [address, setAddress] = useState({});

  useEffect(() => {
    setAddress(addresses[props.question.addressSelected]);
  });

  return (
    <div className="message-line">
      <div className="message-receive">
        <div className="address-content">
          <div>
            <p>
              <strong>Rua: </strong> {address.address}
            </p>
            <p>
              <strong>Número: </strong> {address.number}
            </p>
            <p>
              <strong>Complemento: </strong> {address.complement}
            </p>
            <p>
              <strong>CEP: </strong> {address.zipCode}
            </p>
            <p>
              <strong>Bairro/Distrito: </strong> {address.neighborhood}
            </p>
            <p>
              <strong>Município: </strong> {address.city}
            </p>
            <p>
              <strong>UF: </strong> {address.state}
            </p>
          </div>
          <div className="icon">
            <img
              src={HandWithSmartphone}
              alt="Mão segurando um celular com GPS sendo exibido na tela"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

MessageAddress.propTypes = {
  question: PropTypes.object
};
